import React, { FC, useEffect, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";

import { withProcedureWraper } from "../..";
import { Routes } from "../../../../AppRoutes";
import { Box } from "../../../../components/box";
import { InputArrayData, InputSelect, InputNumber, InputTextArea } from "../../../../components/input";
import { Button } from "../../../../modules/button";
import { InputWraper, useForm } from "../../../../modules/form";
import { useSelector } from "../../../../store/store";
import { CodeProcessContentStructure, CodeProcessContentForm } from "./codeProcessContentForm";
import { CreateNotification } from "../../../../components/notifier";
import { Icon } from "../../../../components/icon";
import { ITCodeRequestService } from "../../../../services/it-code-request/itCodeRequest.service";
import { MailService } from "../../../../services/mail/mail.service";
import { codeProcessTypes } from "./codeRequestType";
import { UserSelect } from "../../../../components/input/select/UserSelect";
import {
  department,
  unitNB,
  unitTSN,
  unitDN,
  hq1Team,
  hq2Team,
  hq3Team,
  psc1Team,
  psc2Team,
  psc3Team,
  pvhk1Team,
  pvhk2Team,
  pvhk3Team,
} from "../data";

import { Col, Row } from "react-bootstrap";

import { getEnv } from "../../../../AppConfigs";
import { mailRegexs } from "../../../../constants/mailTemplateConstants";
import { requestStatus } from "../../../../constants/statusConstants";
import { PeoplePicker, PersonType } from "@microsoft/mgt-react";
import { validatePhoneNumber, validateRequests } from "../../../../services/util";
import { getDDMMYYYFormat, getHHmmFormat } from "../../../../helper/dateTimeHelper";
import { Upload } from "../../upload";
import { InputSelectTag } from "../../../../components/input/select-tag";
import { useQueryClient } from "@tanstack/react-query";
import { eApproveTitleCode } from "../../../../constants/bizTitle";

const siteUrl = getEnv("REACT_APP_APPROVER_IT_CODE_REQUESTS_URL");

export const renewProcessCodeVmsNewPage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const { id } = useRouteMatch().params as any;
  const employees = useSelector((state: any) => state.employee.employees);
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  const [approverOptions, setApproverOptions] = useState([]);
  const [approver, setApprover] = useState("");
  const [requestType, setRequestType] = useState(codeProcessTypes[0].value);
  const [softwareSelected, setSoftwareSelected] = useState(null as any);
  const [itProgam, setItProgam] = useState<any[]>(
    softwares.filter((software: any) => software.eSystemType === codeProcessTypes[0].value),
  );
  const [selectedDepartment, setSelectedDepartment] = useState(null as any);
  const [selectedUnit, setSelectedUnit] = useState(null as any);
  const [selectedTeam, setSelectedTeam] = useState(null as any);
  const [unit, setUnit] = useState<any>([]);
  const [team, setTeam] = useState<any>([]);
  const [pickedUserName, setPickedUserName] = useState(null as any);
  const queryClient = useQueryClient();

  const { getInputProps, handleSubmit, isSubmitting, setValues } = useForm({
    structure: [
      {
        name: "stage",
        label: "Chương trình",
      },
      {
        name: "phoneNumber",
        label: "SĐT liên hệ",
      },
      {
        name: "description",
        label: "Mô tả",
      },
      {
        name: "pickApprover",
        label: "Người duyệt",
      },
      {
        name: "findApprover",
        label: "Người duyệt thay thế",
      },
      {
        name: "application",
        label: "Chương trình",
      },
      {
        name: "deparment",
        label: "Cơ quan/ Đơn vị",
      },
      {
        name: "unit",
        label: "Đơn vị",
      },
      {
        name: "union",
        label: "Đội/Tổ",
      },
      {
        name: "type",
        label: "Yêu cầu",
      },
      {
        name: "requests",
        label: "Nội dung chi tiết",
        defaultValue: [],
      },
      {
        name: "fileRequests",
        label: "Tệp đính kèm",
        defaultValue: [],
      },
    ],
    onSubmit: async (payload) => {
      const { description, phoneNumber, requests, fileRequests } = payload;

      if (!phoneNumber) {
        CreateNotification({ title: "Thông báo", body: "Vui lòng nhập SĐT liên hệ!", icon: "/icons/warning.png" });
        return;
      }

      const formattedValue = phoneNumber.toString().padStart(10, "0");

      if (!validatePhoneNumber(formattedValue)) {
        CreateNotification({ title: "Thông báo", body: "Số điện thoại không hợp lệ!", icon: "/icons/warning.png" });
        return;
      }

      if (requests.length === 0) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
        return;
      }

      /**
       * Validate data of requests is valid ??
       */
      if (requests.length) {
        const isValidateAllRequests = validateRequests(requests);

        if (!isValidateAllRequests) {
          CreateNotification({
            title: "Thông báo",
            body: "Nội dung chi tiết chứa dữ liệu không hợp lệ!",
            icon: "/icons/warning.png",
          });
          return;
        }
      }

      if (!approver) {
        CreateNotification({ title: "Thông báo", body: "Vui lòng chọn thủ trưởng CQ/ĐV!", icon: "/icons/warning.png" });
        return;
      }

      const approverTmp = employees.find((f: any) => f.eMail === approver);
      const software: any = softwares.find((f: any) => f.id === softwareSelected);
      const requestTypeText: any = codeProcessTypes.find((f: any) => f.value === requestType)?.label;
      const assignees = software.eITStaff.split(";");

      const commonFields = {
        Title: `${requestTypeText} - ${software.Title}`,
        eSoftwareId: software.id,
        eDescription: description,
        eContent: JSON.stringify(requests),
        eFileContent: JSON.stringify(fileRequests),
        ePhoneNumber: formattedValue,
      };

      const itCodeRequest: any = {
        fields: {
          ...commonFields,
        },
      };

      const addRequestFields = {
        fields: {
          ...itCodeRequest.fields,
          eRequestStatus: requestStatus.submitted,
          eApprovedBy: approverTmp ? `${approverTmp.eMail}|${approverTmp.Title}` : `${approver}|${pickedUserName}`,
          eRequestType: requestType,
          eApprovedByITLead: `${software.eITTeamLead}|${software.eTeamLeadName}`,
          eApprovedByITHead: `${software.eITHead}|${software.eITHeadName}`, // Uncomment if needed
          eAssignee: `${assignees[0]}`,
          eDepartment: selectedDepartment.value,
          eUnit: selectedUnit.value,
          eUnion: selectedTeam.value,
        },
      };
      addITCodeRequest(addRequestFields);
    },
  });

  const sendMail = async (approver: any, itCodeRequest: any) => {
    const arr = approver.split("|");
    const url = siteUrl + "/details/" + itCodeRequest.id;
    const tomail = arr.length > 0 ? arr[0] : "";
    const name = arr.length > 1 ? arr[1] : "";
    const template = mailtemplates.find((m: any) => m.eMailType === "ITCRA");
    const content = template.eContent
      .replace(mailRegexs.zero + ";", name)
      .replace(mailRegexs.one + ";", "duyệt")
      .replace(mailRegexs.two + ";", itCodeRequest.createdBy.user.displayName)
      .replace(mailRegexs.nine + ";", itCodeRequest.id)
      .replace(mailRegexs.ten + ";", itCodeRequest.fields.eDescription ?? "")
      .replace(
        mailRegexs.three + ";",
        `${getDDMMYYYFormat(itCodeRequest.createdDateTime)} - ${getHHmmFormat(itCodeRequest.createdDateTime)}`,
      )
      .replace(mailRegexs.siteUrl, url);
    const subject = template.eSubject;
    const message = MailService.buildMailMesssage(subject, content, "html", tomail);
    await MailService.sendMail(message);
  };

  const addITCodeRequest = (itCodeRequest: any) => {
    ITCodeRequestService.addITCodeRequest(itCodeRequest).then(
      (res) => {
        CreateNotification({
          title: "Thành công",
          body: `Tạo yêu cầu thành công.`,
          icon: "/icons/success.png",
        });
        if (itCodeRequest.fields.eApprovedBy) {
          sendMail(itCodeRequest.fields.eApprovedBy, res);
        }
        queryClient.invalidateQueries({ queryKey: ["code-process-requests"] });
        history.push(Routes.processCodeGrantedDetailPage.path.replace(":id", res.id));
      },
      (error) => {
        CreateNotification({
          title: "Thất bại",
          body: `Tạo yêu cầu thất bại.`,
          icon: "/icons/error.png",
        });
        console.log(error);
      },
    );
  };

  const onSoftwareChange = (selectedOptions: any) => {
    setSoftwareSelected(selectedOptions ? selectedOptions.value : "");
  };
  //Hàm onChange cho field cơ quan/đơn vị
  const onDepartmentChange = (selectedOptions: any) => {
    setApprover("");
    setSelectedDepartment(selectedOptions ? selectedOptions : null);
    setSelectedTeam(null);
    setTeam([]);
    if (selectedOptions && typeof selectedOptions.id === "string") {
      setSelectedUnit(selectedOptions);
      setSelectedTeam(selectedOptions);
    }
  };

  const onUnitChange = (selectedOptions: any) => {
    setSelectedUnit(selectedOptions ? selectedOptions : null);
    setApprover("");
    setSelectedTeam(null);
  };

  const onTeamChange = (selectedOptions: any) => {
    setSelectedTeam(selectedOptions ? selectedOptions : null);
  };

  //End
  const onApproverChange = (selectedOptions: any) => {
    setApprover(selectedOptions ? selectedOptions.value : "");
  };

  const onApproverPickerChange = (selectedOptions: any) => {
    setApprover(
      selectedOptions.target.selectedPeople[0]
        ? selectedOptions.target.selectedPeople[0].userPrincipalName.toLowerCase()
        : null,
    );
    setPickedUserName(
      selectedOptions.target.selectedPeople[0] ? selectedOptions.target.selectedPeople[0].displayName : null,
    );
  };

  const getApproverOptions = () => {
    let approvers: any = [];
    if (selectedDepartment && selectedDepartment.id > 0 && selectedUnit)
      approvers = employees
        .filter((f: any) => eApproveTitleCode.indexOf(f.eBizTitleCode) > -1 && f.eDepartmentCode === selectedUnit.id)
        .map((o: any) => ({
          label: o.Title,
          value: o.eMail,
          default: o.eDefault || false,
        }));
    // eslint-disable-next-line eqeqeq
    else if (selectedDepartment && selectedDepartment.id != 0)
      approvers = employees
        .filter(
          (f: any) => eApproveTitleCode.indexOf(f.eBizTitleCode) > -1 && f.eDepartmentCode === selectedDepartment.id,
        )
        .map((o: any) => ({
          label: o.Title,
          value: o.eMail,
          default: o.eDefault || false,
        }));
    setApproverOptions(approvers);
  };

  const handleSelectChange = (e: string) => {
    setRequestType(e);
    const progam = softwares.filter((software: any) => software.eSystemType === e);
    setItProgam(progam);
    setSoftwareSelected(null);
  };
  //Set hook cho Cơ quan/Đơn vị
  useEffect(() => {
    if (selectedDepartment) {
      if (selectedDepartment.id === 2) {
        setUnit(unitNB);
        setSelectedUnit(null);
      } else if (selectedDepartment.id === 3) {
        setUnit(unitDN);
        setSelectedUnit(null);
      } else if (selectedDepartment.id === 1) {
        setUnit(unitTSN);
        setSelectedUnit(null);
      } else {
        setUnit([{ id: selectedDepartment.id, value: selectedDepartment.value }]);
        setSelectedUnit(selectedDepartment);
      }
    }
  }, [selectedDepartment]);

  useEffect(() => {
    if (selectedUnit && selectedUnit.id) {
      if (selectedDepartment.id === 1 || selectedDepartment.id === 2 || selectedDepartment.id === 3) {
        const id = +selectedUnit?.id?.slice(-1);
        const key = selectedUnit?.id?.slice(0, -1);
        if (key === "HQ") setTeam(id === 1 ? hq1Team : id === 2 ? hq2Team : id === 3 ? hq3Team : []);
        else if (key === "PSC") setTeam(id === 1 ? psc1Team : id === 2 ? psc2Team : id === 3 ? psc3Team : []);
        else if (key === "PVHK") setTeam(id === 1 ? pvhk1Team : id === 2 ? pvhk2Team : id === 3 ? pvhk3Team : []);
        else if (key === "GA") setTeam([{ id: "GA", value: "Bộ phận hành chính tổng hợp" }]);
        else if (key === "PVHH") setTeam([{ id: "PVHH", value: "Đội phục vụ hàng hóa" }]);
        else {
          setTeam([{ id: selectedUnit.id, value: selectedUnit.value }]);
          setSelectedTeam(selectedUnit);
        }
      } else {
        setTeam([{ id: selectedDepartment.id, value: selectedDepartment.value }]);
        setSelectedTeam(selectedDepartment);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUnit]);

  useEffect(() => {
    getApproverOptions();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDepartment, selectedUnit]);

  useEffect(() => {
    // eslint-disable-next-line eqeqeq
    if (id != 0) {
      ITCodeRequestService.getITCodeRequest(id)
        .then((res) => {
          const {
            eDescription,
            eSoftwareId,
            eRequestType,
            eContent,
            eFileContent,
            ePhoneNumber,
          } = res.fields;
          setValues({
            description: eDescription,
            requests: JSON.parse(eContent),
            fileRequests: JSON.parse(eFileContent),
            phoneNumber: ePhoneNumber,
          });
          setRequestType(eRequestType);
          setSoftwareSelected(eSoftwareId);
          // setApprover(approverEmail);
          // setSelectedDepartment(eDepartment);
          // setSelectedUnit(eUnit);
        })
        .catch((error) => console.log(error));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div className="ITCodeGrantedCreateNewPage">
      <div className="pd15">
        <div className="PageHead">
          <div className="title">
            <div className="btnBack" onClick={() => history.push(Routes.procedureProcessVms.path)}>
              <Icon.ArrowLeft />
            </div>
            {"Tạo Yêu Cầu Cấp Quyền Sử Dụng Chương Trình"}
          </div>
        </div>

        <Box title="Thông tin" className="form__content">
          <form onSubmit={handleSubmit}>
            {/* <Row>
              <Col sm="6" md="6">
                <InputWraper inputProps={getInputProps('deparment')} renderInput={(s) =>
                <InputSelect {...s}
                    options={department.map((o: any) => ({ label: o, value: o }))}
                    value={selectedDepartment}
                    onChange={onDepartmentChange}
                    placeholder="* Chọn Cơ quan/ đơn vị" />}
                />
              </Col>
              <Col sm="6" md="6">
                <InputWraper inputProps={getInputProps('unit')} renderInput={(s) =>
                <InputSelect {...s}
                    options={getUnitByDepartment()}
                    value={selectedUnit}
                    onChange={onUnitChange}
                    placeholder={getUnitByDepartment() ? "* Chọn đơn vị" : selectedDepartment} />}
                />
              </Col>
            </Row> */}
            <Row>
              <Col sm="12" md="12">
                <InputWraper
                  className="pb-3"
                  inputProps={getInputProps("stage")}
                  renderInput={(s) => (
                    <InputSelectTag
                      {...s}
                      options={codeProcessTypes}
                      value={requestType}
                      onChange={handleSelectChange}
                    />
                  )}
                  isRequired
                />
              </Col>
            </Row>
            {/* {id == 0 && ( */}
            {true && (
              <Row>
                <Col sm="6" md="6">
                  <InputWraper
                    inputProps={getInputProps("deparment")}
                    renderInput={(s) => (
                      <InputSelect
                        {...s}
                        options={department.map((o: any) => ({
                          id: o.id,
                          label: o.value,
                          value: o.value,
                        }))}
                        value={selectedDepartment}
                        onChange={onDepartmentChange}
                        placeholder="* Chọn Cơ quan/ đơn vị"
                      />
                    )}
                  />
                </Col>
                <Col sm="6" md="6">
                  <InputWraper
                    inputProps={getInputProps("unit")}
                    renderInput={(s) => (
                      <InputSelect
                        {...s}
                        options={unit.map((o: any) => ({
                          id: o.id,
                          label: o.value,
                          value: o.value,
                        }))}
                        value={selectedUnit?.value}
                        onChange={onUnitChange}
                        placeholder={"* Chọn đơn vị"}
                      />
                    )}
                  />
                </Col>
              </Row>
            )}
            <Row>
              <Col sm="6" md="6">
                <InputWraper
                  inputProps={getInputProps("union")}
                  renderInput={(s) => (
                    <InputSelect
                      {...s}
                      options={team.map((o: any) => ({
                        id: o.id,
                        label: o.value,
                        value: o.value,
                      }))}
                      value={selectedTeam?.value}
                      onChange={onTeamChange}
                      placeholder="* Chọn đội/tổ"
                    />
                  )}
                />
              </Col>
              <Col sm="6" md="6">
                <InputWraper
                  inputProps={getInputProps("application")}
                  renderInput={(s) => (
                    <InputSelect
                      {...s}
                      options={itProgam.map((o: any) => ({
                        label: o.Title,
                        value: o.id,
                      }))}
                      value={softwareSelected}
                      onChange={onSoftwareChange}
                      placeholder="* Chọn chương trình muốn cấp"
                    />
                  )}
                />
              </Col>
            </Row>
            <InputWraper
              inputProps={getInputProps("phoneNumber")}
              renderInput={(s) => <InputNumber {...s} />}
              isRequired
            />
            <InputWraper inputProps={getInputProps("description")} component={InputTextArea} />

            <InputWraper
              className="from__container-input"
              inputProps={getInputProps("requests")}
              renderInput={(state) => (
                <InputArrayData
                  {...state}
                  form={CodeProcessContentForm}
                  structure={CodeProcessContentStructure}
                  excelTemplate="list-cost"
                />
              )}
            />

            <InputWraper inputProps={getInputProps("fileRequests")} renderInput={(s) => <Upload {...s} />} />

            {/* {id == 0 && ( */}
            {true && (
              <Row>
                <Col sm="6" md="6">
                  <InputWraper
                    inputProps={getInputProps("pickApprover")}
                    renderInput={(s) => (
                      <UserSelect
                        {...s}
                        placeholder="Thủ trưởng CQ/ĐV"
                        options={approverOptions}
                        value={approver}
                        onChange={onApproverChange}
                      />
                    )}
                    isRequired={id === "0"}
                  />
                </Col>
                <Col sm="6" md="6">
                  <InputWraper
                    inputProps={getInputProps("findApprover")}
                    renderInput={(s) => (
                      <div className="people_picker-custom">
                        <PeoplePicker
                          className="people-picker"
                          placeholder="Thủ trưởng CQ/ĐV"
                          type={PersonType.any}
                          selectionChanged={onApproverPickerChange}
                        />
                      </div>
                    )}
                  />
                </Col>
              </Row>
            )}
            <div className="textRight">
              <Button type="submit" label="Xác nhận" isLoading={isSubmitting} />
              <Button
                type="button"
                label="Huỷ"
                buttonType="danger-outline"
                className="ml10"
                onClick={() => history.push(Routes.procedureProcessVms.path)}
              />
            </div>
          </form>
        </Box>
      </div>
    </div>
  );
});
